import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, ProgressBar } from "react-bootstrap";
import LightSpeed from "react-reveal/LightSpeed";

// Array of skills
const skills = [
  {
    name: "Communication Skills",
    percentage: 90,
    color: "#fe3e57",
    variant: "danger",
  },
  {
    name: "Project Management",
    percentage: 85,
    color: "#54faae",
    variant: "success",
  },
  {
    name: "Problem Solving",
    percentage: 81,
    color: "#ff8c2f",
    variant: "warning",
  },
  {
    name: "Analytical Abilities",
    percentage: 77,
    color: "#f1f965",
    variant: "info",
  },
  { name: "Organization", percentage: 87, color: "#ff0173", variant: "pink" },
  { name: "Creativity", percentage: 79, color: "#39c4ff", variant: "primary" },
];

export default function PersonalSkill() {
  return (
    <div>
      {/* Navigation Buttons */}
      <div className="mt-5 d-flex flex-row justify-content-center">
        <Link className="btn btn-primary me-3" to="/technicalSkill">
          Technical Skill
        </Link>
        <Link className="btn btn-primary me-3" to="/personalskill">
          Personal Skill
        </Link>
        <Link className="btn btn-primary" to="/toolkit">
          Toolkit
        </Link>
      </div>

      {/* Animated Header */}
      <LightSpeed left cascade>
        <h1 className="mt-4 text-center">Personal Skills</h1>
      </LightSpeed>

      {/* Dynamic Skills Section */}
      <div className="mt-4">
        <Container>
          <Row className="g-5">
            {skills.map((skill, index) => (
              <Col md={4} key={index}>
                <h1
                  style={{
                    fontSize: "100px",
                    color: skill.color,
                    fontWeight: 700,
                  }}
                >
                  {skill.percentage}%
                </h1>
                <div style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                  <ProgressBar
                    now={skill.percentage}
                    style={{ height: "10px" }}
                  />
                  <h2
                    style={{
                      color: skill.color,
                      fontSize: "25px",
                      marginTop: "13px",
                      fontWeight: 700,
                    }}
                  >
                    {skill.name}
                  </h2>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
}
